module.exports = __webpack_public_path__ + "static/media/icon-profile.de4e1088.png";